import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n.js';
import { RouterProvider } from 'react-router-dom';
import routes from './router/Router.jsx';
import 'mapbox-gl/dist/mapbox-gl.css';
import { ConfigProvider } from 'antd';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import dayjs from 'dayjs';
import { logoutEv } from './models/authModel/index.js';

dayjs.extend(quarterOfYear);

const allowedOrigin = __API_URL__;

window.addEventListener('message', (event) => {
  if (event.origin !== allowedOrigin.split('/api')[0]) {
    return;
  }

  const { parentUrl } = event.data;
  window.parentUrl = parentUrl;
});

const halyk_script = document.createElement('script');
halyk_script.setAttribute('src', __HALYK_URL__);
document.body.appendChild(halyk_script);

// Auto logout
let timer;

const events = [
  'load',
  'mousemove',
  'mousedown',
  'click',
  'scroll',
  'keypress',
];

const resetTimer = () => {
  if (timer) {
    clearTimeout(timer);
  }
};

const handleLogoutTimer = () => {
  if (!window.location.pathname.includes('public-pages')) {
    timer = setTimeout(() => {
      resetTimer();
      events.forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });

      logoutEv();
    }, 900000); // timeout in milliseconds - 900 000 = 15 mins
  }
};

events.forEach((item) => {
  window.addEventListener(item, () => {
    resetTimer();
    handleLogoutTimer();
  });
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#2F54EB',
          colorPrimaryBg: '#F0F5FF',
          colorTextBase: '#000000D9',
          colorText: '#000000D9',
          colorTextDisabled: '#00000040',
          colorTextDescription: '#00000073',
          colorWarning: '#FAAD14',
          colorError: '#FF4D4F',
          colorIcon: '#2F54EB',
          colorSuccess: '#9AD73A',
          fontFamily: 'Noto Sans',
        },
      }}
    >
      <RouterProvider router={routes} />
    </ConfigProvider>
  </React.StrictMode>
);
